module.exports = __webpack_public_path__ + "static/media/burger.6cb67002.png";